import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://caaeduardo.github.io/Charles-SupportTech//" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://caaeduardo.github.io/Charles-SupportTech/" target="_blank" rel="noreferrer"><h2>Charles²</h2></a>
                <p>Charles² is a help desk software solution designed specifically for small and medium-sized businesses looking to streamline their operational processes.</p>
            </div>
            <div className="project">
                <a href="" target="_blank" rel="noreferrer"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="" target="_blank" rel="noreferrer"><h2>TaskFlow ToDo App</h2></a>
                <p>TaskFlow is a web application that allows users to create and manage tasks, set due dates, and track their progress.</p>
            </div>
            <div className="project">
                <a href="" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="" target="_blank" rel="noreferrer"><h2>CAFF Fisioterapia</h2></a>
                <p>CAFF fisioterapia is a Site web for a fisioterapia company.</p>
            </div>
            <div className="project">
                <a href="https://caaeduardo.github.io/Clock-time/" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://caaeduardo.github.io/Clock-time/" target="_blank" rel="noreferrer"><h2>Clock Time W/ Spotify</h2></a>
                <p>Clock Time is a web application that allows users to create and manage tasks, set due dates, and track their progress.</p>
            </div>
            <div className="project">
                <a href="https://cepheus-web-site.vercel.app/" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://cepheus-web-site.vercel.app/" target="_blank" rel="noreferrer"><h2>CePheus Web Site</h2></a>
                <p>CePheus is a web site for a construction company.</p>
            </div>
            <div className="project">
                <a href="" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="" target="_blank" rel="noreferrer"><h2>Project User Register - UAM </h2></a>
                <p>This project is a web application that allows users to create and manage tasks, set due dates, and track their progress.</p>
            </div>
            
        </div>
    </div>
    );
}

export default Project;